import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import singhcoin from "assets/images/singhCoinCurrency.png";

import React from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { useMediaQuery } from "react-responsive";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Avatar,
  Box,
  CardContent,
  CardHeader,
  CardMedia,
  DialogActions,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { getListCampaigns } from "services/apiService";
import CampaignsLoader from "components/SkeletonLoader/campaignsLoader";
import MDButton from "components/MDButton";
import CreatePost from "layouts/createpost";
import { useDispatch, useSelector } from "react-redux";
import { campaignReducer } from "Store/slices/campaignSlice";

function Campaigns() {
  const dispatch = useDispatch();
  const { campaignList, campaignLoading, campaignPageNumber } = useSelector(
    (state) => state.campaigns
  );
  // const [campaignList, setCampaignList] = useState([]);
  const [pageLoader, setPageLoader] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetchMore, setIsFetchMore] = useState(false);
  const [createPostBoolean, setCreatePostBoolean] = useState(false);
  const [isParticipate, setIsParticipate] = useState(false);
  const [participateData, setParticipateData] = useState("");
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchCampaignList();
  }, []);

  const fetchCampaignList = async () => {
    // setPageLoader(true);
    // const campaignListRes = await getListCampaigns(pageNumber);
    // // console.log("campaignListRes", campaignListRes);
    // setCampaignList(campaignListRes);
    // setPageLoader(false);
    // if (campaignListRes.length > 1) {
    //   setIsFetchMore(true);
    // }
    // setPageNumber((prev) => prev + 1);

    if (campaignLoading) {
      const campaignListRes = await getListCampaigns(campaignPageNumber);
      dispatch(campaignReducer(campaignListRes));
    }
  };

  // const fetchMoreData = async () => {
  //   const campaignListResNew = await getListCampaigns(pageNumber);
  //   if (campaignListResNew.length < 1) {
  //     setIsFetchMore(false);
  //     return;
  //   }
  //   setIsFetchMore(true);
  //   setCampaignList(campaignList.concat(campaignListResNew));
  //   setPageNumber((prev) => prev + 1);
  // };

  const handleParticipate = (booleanValue, item) => {
    setIsParticipate(booleanValue);
    setParticipateData(item);
    setCreatePostBoolean(true);
  };

  const handleClose = () => {
    setCreatePostBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container>
          {/* <InfiniteScroll
            dataLength={campaignList.length}
            next={fetchMoreData}
            hasMore={isFetchMore}
            loader={
              <MDBox sx={{ textAlign: "center" }}>
                <SpinLoader />
              </MDBox>
            }
          > */}
          {campaignLoading ? (
            <CampaignsLoader />
          ) : campaignList.length > 0 ? (
            campaignList.map((item, idx) => (
              <Card
                key={idx}
                sx={{ marginBottom: "1rem", border: "1px solid #6a6a6a" }}
              >
                <CardContent>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        container
                        xs={12}
                        md={6}
                        sx={{ justifyContent: "center" }}
                      >
                        <CardMedia
                          sx={{
                            width: "100%",
                            height: "400px",
                          }}
                          component="img"
                          image={item.campaignImage}
                          alt="green iguana"
                        />
                      </Grid>
                      <Grid item container xs={12} md={6}>
                        <CardHeader
                          title={
                            <MDTypography sx={{ fontWeight: "700" }}>
                              {item.campaignName}
                            </MDTypography>
                          }
                          subheader={
                            <MDTypography sx={{ fontSize: "15px" }}>
                              {item.description}
                            </MDTypography>
                          }
                        />
                        {/* <MDBox
                          sx={{
                            position: "absolute",
                            top: 50,
                            marginLeft: "220px",
                            height: "25px",
                            width: "90px",
                            backgroundColor: "#ff0101",
                            opacity: "60%",
                            borderRadius: "15px",
                            textAlign: "center",
                          }}
                        >
                          <MDTypography
                            sx={{ color: "#ffffff",
                            margin:"4px",
                            fontSize:"10px",
                            fontWeight:"700"
                             }}
                            fontSize="small"
                          >
                            {item.status}
                          </MDTypography>
                        </MDBox> */}

                        <Grid
                          container
                          sx={{
                            marginBottom: "18px",
                            // marginLeft: "18px"
                          }}
                        >
                          <MDBox
                            sx={{
                              position: "absolute",
                              top: 50,
                              marginLeft: "220px",
                              height: "25px",
                              width: "90px",
                              backgroundColor: "#ff0101",
                              opacity: "60%",
                              borderRadius: "15px",
                              textAlign: "center",
                            }}
                          >
                            <MDTypography
                              sx={{
                                color: "#ffffff",
                                margin: "4px",
                                fontSize: "10px",
                                fontWeight: "700",
                              }}
                              fontSize="small"
                            >
                              {item.status}
                            </MDTypography>
                          </MDBox>
                          <MDTypography
                            // component="a"
                            // href="#"
                            // variant="button"
                            fontWeight="bold"
                            color="info"
                            textGradient
                          >
                            Terms and Conditions
                          </MDTypography>
                          <Grid item xs={12}>
                            <Stack direction="row">
                              <Avatar
                                src={singhcoin}
                                sx={{ width: 50, height: 50 }}
                              />
                              <Typography
                                sx={{ fontSize: 28, fontWeight: "700" }}
                                color="#ff9609"
                              >
                                {item.campaignRewardAmount}.00
                              </Typography>
                            </Stack>
                            <MDTypography sx={{ fontSize: "15px" }}>
                              Campaign Rewards
                            </MDTypography>
                            <Grid item xs={12} lg={8}>
                              <Grid container spacing={3}>
                                <Grid item xs={6} md={6}>
                                  <CardHeader
                                    sx={{ textAlign: "center" }}
                                    title={
                                      <MDTypography sx={{ fontWeight: "700" }}>
                                        {item.totalRemainingDays}
                                      </MDTypography>
                                    }
                                    subheader={
                                      <MDTypography sx={{ fontSize: "15px" }}>
                                        Days left
                                      </MDTypography>
                                    }
                                  />
                                  <MDButton
                                    disabled={item.status === "UPCOMING"}
                                    color="singh"
                                    sx={{
                                      minWidth: isTabletOrMobile
                                        ? "100%"
                                        : "130px",
                                      borderRadius: "2.5rem",
                                    }}
                                    onClick={() =>
                                      handleParticipate(true, item)
                                    }
                                  >
                                    Participate
                                  </MDButton>
                                </Grid>
                                <Grid item xs={6} md={6}>
                                  <CardHeader
                                    sx={{ textAlign: "center" }}
                                    title={
                                      <MDTypography sx={{ fontWeight: "700" }}>
                                        {item.totalParticipants}
                                      </MDTypography>
                                    }
                                    subheader={
                                      <MDTypography sx={{ fontSize: "15px" }}>
                                        Participants
                                      </MDTypography>
                                    }
                                  />
                                  <MDButton
                                    color="white"
                                    sx={{
                                      minWidth: isTabletOrMobile
                                        ? "100%"
                                        : "130px",
                                      borderRadius: "2.5rem",
                                    }}
                                    //  onClick={() => handlePost()}
                                  >
                                    {" "}
                                    Following
                                  </MDButton>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            ))
          ) : (
            <MDBox
              sx={{
                width: "100%",
                textAlign: "center",
              }}
            >
              <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                No Campaigns Added Yet!
              </MDTypography>
            </MDBox>
          )}
          {/* </InfiniteScroll> */}
        </Grid>
      </MDBox>
      {/* <Footer /> */}
      {createPostBoolean && (
        <CreatePost
          openStatus={createPostBoolean}
          onClose={() => handleClose()}
          isParticipate={isParticipate}
          participateData={participateData}
        />
      )}
    </DashboardLayout>
  );
}
export default Campaigns;
